const orderApprovePageParams = {
  operateType: null, // 操作类型
  identity: null, // 身份
  approvalStep: 0, // 审批阶段
  appCode: null // 订单号
}

export {
  orderApprovePageParams
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.page.parameter.js